import { Dropdown } from 'react-bootstrap';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import withComponentName from '../../../../../../decorators/withComponentName';

const DropdownRow = ({
  isSelectAll,
  id,
  name,
  fullName,
  select,
  handleRowSelect,
}) => {
  const handleSelect = () => {
    const value = {
      sources_id: id,
      name,
      full_name: fullName,
    };
    handleRowSelect(value, select);
  };

  return (
    <Dropdown.Item eventKey={id} active={isSelectAll || select} onSelect={handleSelect}>
      <FontAwesomeIcon icon={(isSelectAll || select) ? faCheckSquare : faSquare} />
      <span className="dropdown__checkbox_title">{fullName}</span>
    </Dropdown.Item>
  );
};

export default withComponentName(DropdownRow);
